import React from 'react';
import LabelValuePanel from '../LabelValuePanel/LabelValuePanel';
import { IAnyPanel } from '../Dashboard.model';
import TrendPanel from '../TrendPanel/TrendPanel';
import PieChartPanel from '../PieChartPanel/PieChartPanel';
import GaugePanel from '../GaugePanel/GaugePanel';
import BarChartPanel from '../BarChartPanel/BarChartPanel';
import DataGridPanel from '../DataGridPanel/DataGridPanel';

interface PanelSelectorProps {
  panel: IAnyPanel;
}
function PanelSelector(props: PanelSelectorProps) {
  const { panel } = props;
  switch (panel.type) {
    case 'LABEL_VALUE':
      return <LabelValuePanel panel={panel} />;
    case 'TREND':
      return <TrendPanel panel={panel} />;
    case 'PIE_CHART':
      return <PieChartPanel panel={panel} />;
    case 'GAUGE':
      return <GaugePanel panel={panel} />;
    case 'BAR_CHART':
      return <BarChartPanel panel={panel} />;
    case 'DATA_GRID':
      return <DataGridPanel panel={panel} />;
    default:
      return <div>Unknown panel type</div>;
  }
}

export default PanelSelector;
